<script setup lang="ts">
import { Slider } from '@/components/ui/slider'

const props = defineProps<{
  terms?: number[] // Принимаем массив доступных сроков
}>()
const emit = defineEmits(['update:modelValue'])
const modelValue = defineModel({
  type: Number,
})
// Преобразуем сроки в индексы для слайдера
const availableTerms = computed(() => props.terms || [])
const positions = computed(() => availableTerms.value.length - 1)

const sliderValue = ref([0])

// Инициализация начального значения
onMounted(() => {
  if (availableTerms.value.length > 0) {
    const initialIndex = availableTerms.value.findIndex(t => t === modelValue.value)
    sliderValue.value = [initialIndex >= 0 ? initialIndex : 0]
  }
})

// Обновляем значение при изменении слайдера
watch(sliderValue, ([newIndex]) => {
  const term = availableTerms.value[newIndex]
  if (term !== undefined) {
    emit('update:modelValue', term)
  }
})

// Корректируем позицию при изменении доступных сроков
watch(availableTerms, (newTerms) => {
  if (newTerms.length > 0) {
    const currentIndex = newTerms.findIndex(t => t === modelValue.value)
    sliderValue.value = [currentIndex >= 0 ? currentIndex : 0]
  }
})

watch(() => modelValue.value, (newValue) => {
  if (newValue !== undefined) {
    const newIndex = availableTerms.value.findIndex(t => t === newValue)
    sliderValue.value = [newIndex >= 0 ? newIndex : 0]
  }
}, { immediate: true })
</script>

<template>
  <div class="w-full relative">
    <Slider
      v-model="sliderValue"
      :max="positions"
      :step="1"
      :min="0"
    />
    <div class="flex justify-between mt-2 h-4">
      <span

        class="text-xs text-muted-foreground"
      >
        {{ props.terms ? props.terms[0] : 0 }} недель
      </span>
      <span

        class="text-xs text-muted-foreground"
      >
        {{ props.terms ? props.terms[props.terms.length - 1] : 0 }} недель
      </span>
    </div>
  </div>
</template>
